interface ImageProps {
  imagePath: string;
  style?: React.CSSProperties;
  styleImage?: React.CSSProperties;
}

const Image = ({ imagePath, style, styleImage }: ImageProps) => (
  <div style={style}>
    <img style={{ display: "block", ...styleImage }} src={require(`../../Assets/images/${imagePath}`)} alt="" />
  </div>
);

export default Image;
